import React from "react";
import styles from "./index.css";
import DeliveryProposition from "./DeliveryProposition";
import BagLinks from "./BagLinks";
import Subtotal from "./SubTotal";

const MinibagFooter = () => (
  <div data-test-id="miniBagFooter" className={styles.minibagFooter}>
    <Subtotal />
    <BagLinks />
    <DeliveryProposition />
  </div>
);

export default MinibagFooter;



// WEBPACK FOOTER //
// ./template/components/MiniBag/Footer/index.js